<template>
  <transition name="fade" v-if="isShow">
    <div id="addressAlert">
      <div class="main">
        <div class="title">选择地址
          <i class="iconfont icon-close" @click="close"></i>
        </div>
        <div class="addr">
          <div :class="['city' + index, addressNum === index ? 'active' : '']" v-for="(item, index) in addressAlert" :key="index" @click="addressClick(index)">{{item}}</div>
        </div>
        <div class="list">
          <div class="menu" v-for="(item, index) in addressData" :key="index" @click="cityClick(index, item)">{{item}}</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import cityData from '../assets/js/address.json';
export default {
  name: 'addressAlert',
  data () {
    return {
      addressAlert: ['请选择', '请选择', '请选择'],
      addressNum: 0,
      addressData: {},
      addressIndex: ''
    };
  },
  computed: {
    isShow () {
      return this.$store.state.addressAlert;
    }
  },
  created () {
    this.beforeAddress();
  },
  methods: {
    close () {
      this.$store.commit('addressAlertChange', false);
      this.addressNum = 0;
      this.addressAlert = ['请选择', '请选择', '请选择'];
    },
    // 首次地址
    beforeAddress () {
      this.addressData = cityData[86];
    },
    // 地址点击事件
    cityClick (index, city) {
      this.addressAlert[this.addressNum] = city;
      this.addressIndex = this.addressNum === 0 ? index : this.addressIndex;
      if (!cityData[index] && this.addressNum === 1) {
        this.addressAlert[2] = '市區';
        this.addressNum = 2;
        this.addressSubmit();
        return false;
      }
      this.addressData = cityData[index];
      if (this.addressNum === 2) {
        this.addressSubmit();
        return false;
      }
      this.addressNum++;
    },
    // 地址提交
    addressSubmit () {
      this.$store.commit('addressAlertChange', false);
      this.callback(this.addressAlert);
      this.addressNum = 0;
      this.addressData = cityData[86];
      this.addressAlert = ['请选择', '请选择', '请选择'];
    },
    // 清楚选择地址，
    addressClick (index) {
      if (index === 0) {
        this.addressData = cityData[86];
        this.addressNum = 0;
        this.addressAlert = ['请选择', '请选择', '请选择'];
      } else {
        this.addressData = cityData[this.addressIndex];
        this.addressNum = 1;
        this.addressAlert[index] = '请选择';
      }
    }
  },
  props: [
    'callback'
  ]
};
</script>

<style lang="scss">
  #addressAlert{
    width: 100%;
    height: 100%;
    min-height: 100%;
    overflow-y: auto;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    transform: 0.3s;
    z-index: 100;
    .main{
      width: 100%;
      height: 790px;
      background: #fff;
      position: absolute;
      left: 0;
      bottom: 0;
      border-radius: 20px 20px 0 0;
      .title{
        width: 100%;
        height: 88px;
        line-height: 88px;
        font-size: 28px;
        color: #282828;
        text-align: center;
        position: relative;
        border-bottom: 1Px solid #e5e5e5;
        .iconfont{
          position: absolute;
          right: 36px;
          top: 0;
          color: #97a2bd;
        }
      }
      .addr{
        box-sizing: border-box;
        width: 100%;
        height: 90px;
        line-height: 90px;
        background: #ffffff;
        overflow: hidden;
        div{
          width: 33%;
          box-sizing: border-box;
          font-size: 26px;
          color: #485668;
          float: left;
          padding: 0 40px;
          height: 68px;
          position: relative;
          &.active{
            color: #31a1f7;
            &:after{
              content: "";
              display: block;
              width: 60px;
              height: 4px;
              background: #31a1f7;
              position: absolute;
              left: 30%;
              top: 78px;
            }
          }
        }
        .city0{
          text-align: left;
          &.active{
            &:after{
              left: 20%;
              top: 78px;
            }
          }
        }
        .city1{
          text-align: center;
          &.active{
            &:after{
              left: 38%;
              top: 78px;
            }
          }
        }
        .city2{
          text-align: right;
          &.active{
            &:after{
              left: 57%;
              top: 78px;
            }
          }
        }
      }
      .list{
        height: 600px;
        overflow: auto;
        text-align: left;
        .top{
          font-size: 24px;
          color: #999;
          margin-left: 38px;
          margin-top: 30px;
        }
        .menu{
          box-sizing: border-box;
          // width: 100%;i
          height: 94px;
          line-height: 94px;
          font-size: 26px;
          color: #939fbb;
          margin: 0 40px;
          border-top: 1Px solid #e5e5e5;
        }
      }
    }
  }
</style>
